import React from 'react';
import { block } from '../../../../../kit/utils';
import { useSearchContext } from '../useSearchContext';
import './useSearch.css';
const b = block('use-search');
export const useSearch = (spec, value, name) => {
    const { setField, removeField, isHiddenField, searchFunction } = useSearchContext();
    const searchResult = React.useMemo(() => !searchFunction(spec, value, name), [name, searchFunction, spec, value]);
    const hidden = React.useMemo(() => isHiddenField(name), [isHiddenField, name]);
    const withSearch = React.useCallback((children) => children ? React.createElement("div", { className: b({ hidden: hidden }) }, children) : null, [hidden]);
    React.useEffect(() => {
        setField(name, searchResult);
    }, [searchResult]);
    React.useEffect(() => {
        return () => removeField(name);
    }, []);
    return withSearch;
};
